<template>
  <div ref="el">
    <Tooltip
      placement="top-start"
      class-name="schedule-board-tooltip travel-event-tooltip"
      style="width: 100%"
      :options="tippyOptions"
    >
      <template #trigger>
        <div class="travel-event-content">
          <!-- Need some inner text to trigger the tooltip  -->
          <!-- Text is hidden via CSS  -->
          Travel Time
        </div>
      </template>
      <template #tooltip>
        <div>
          <div class="d-flex flex-column">
            <div class="tooltip-section">
              <div class="tooltip-row">
                <span>Travel Job #</span>
                <span>{{ details.job_id }}</span>
              </div>
            </div>
            <div class="tooltip-section">
              <div class="tooltip-row">
                <span>Start</span>
                <span>{{ formatDate(event.start, "h:mm A") }}</span>
              </div>
              <div class="tooltip-row">
                <span>End</span>
                <span>{{
                  details.status !== "accepted"
                    ? formatDate(event.end, "h:mm A")
                    : "--"
                }}</span>
              </div>
              <div class="tooltip-row">
                <span>Duration</span>
                <span><minutes-label :minutes="duration"></minutes-label></span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Tooltip>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters } from "vuex";
import { getMinuteDiff } from "@/lib/helpers.js";

import MinutesLabel from "@/components/MinutesLabel.vue";
import Tooltip from "@/components/Tooltip.vue";

export default {
  components: {
    Tooltip,
    MinutesLabel
  },
  props: {
    event: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(["featureEnabledForTenant"]),
    details() {
      return this.event.extendedProps;
    },
    duration() {
      // FIXME: minute based math
      return this.details.status !== "accepted"
        ? getMinuteDiff(this.event.end, this.event.start)
        : null;
    },
    tippyOptions() {
      return {
        interactive: false,
        delay: [0, 0],
        onShow() {
          tippy.hideAll();
        }
      };
    }
  },
  methods: {
    formatDate(date, format) {
      return moment(date).format(format);
    }
  }
};
</script>

<style lang="scss" scoped>
.travel-event-content {
  color: transparent;
  min-height: 32px;
}
</style>
